export function formatViews(views: number): string {
  if (views >= 100000000) {
    return `${(views / 100000000).toFixed(1)} 亿`;
  }
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export function formatRating(rating: number): string {
  return rating.toFixed(1);
}